<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-title class="aligned"><img [src]="compData[compMod].titleIcon" width="50px"><span>{{compData[compMod].title}}</span></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
<ion-grid style="height: 100%;">
  <ion-row style="height: 100%;">
    <ion-col size="8">


  <div id="grid-wrapper" style="width: 100%; height: 100%" *ngIf="rowData">
  <ag-grid-angular
  [localeText]="AG_GRID_LOCALE_HU"
  style="width: 100%; height: 100%;"
  (selectionChanged)="onSelectionChanged($event)"
  (gridReady)="onGridReady($event)"
  (gridSizeChanged)="onGridSizeChanged($event)"
  class="ag-theme-quartz-auto-dark"
  rowSelection='single'
  [rowData]="rowData"
  [columnDefs]="compData[compMod].colDefs" />
</div>


</ion-col>
<ion-col>
  <ng-container *ngFor="let item of compData[compMod].buttons">
    <ion-button color="light" expand="block" *ngIf="item.type=='button'" [disabled]="item.disabled" (click)="openComponent(item.to,item.rw)">
      <div style="width: 100%; text-align:left;">
        <img [src]="item.icon" width="50px">
        <ion-label>{{item.label}}</ion-label>
      </div>
    </ion-button>
    <br *ngIf="item.type=='break'">
  </ng-container>
  
  <!--ion-button color="light" expand="block"  [disabled]="!selectedRow">
    <div style="width: 100%; text-align:left;">
      <img src="assets/icon/icons8-edit-property-96.png" width="50px">
      <ion-label>Módosítás</ion-label>
    </div>
  </ion-button>
  <ion-button color="light" expand="block" [disabled]="!selectedRow">
    <div style="width: 100%; text-align:left;">
      <img src="assets/icon/icons8-delete-96.png" width="50px">
      <ion-label>Törlés</ion-label>
    </div>
  </ion-button>
  <br>
  <ion-button color="light" expand="block" [disabled]="!selectedRow">
    <div style="width: 100%; text-align:left;">
      <img src="assets/icon/icons8-time-96.png" width="50px">
      <ion-label>Órák</ion-label>
    </div>
  </ion-button>
  <ion-button color="light" expand="block" [disabled]="!selectedRow">
    <div style="width: 100%; text-align:left;">
      <img src="assets/icon/icons8-schedule-96.png" width="50px">
      <ion-label>Idősáv</ion-label>
    </div>
  </ion-button>
  <ion-button color="light" expand="block" [disabled]="!selectedRow">
    <div style="width: 100%; text-align:left;">
      <img src="assets/icon/icons8-flow-chart-96.png" width="50px">
      <ion-label>Korlátozások</ion-label>
    </div>
  </ion-button>

  <ion-button color="light" expand="block" [disabled]="!selectedRow">
    <div style="width: 100%; text-align:left;">
      <img src="assets/icon/icons8-group-96.png" width="50px">
      <ion-label>Csoportok</ion-label>
    </div>
  </ion-button-->
</ion-col>
</ion-row>
</ion-grid>
</ion-content>